import { IconProps } from '@euler/app/components/icons/types';
import { GradientIconProps } from '@euler/app/tv/theme/types';
import { FC, memo } from 'react';
import Svg, { Defs, LinearGradient, Path, Stop } from 'react-native-svg';

export const ServiceAgentIcon: FC<IconProps & GradientIconProps> = memo(
  ({
    width,
    height,
    size = 16,
    color = 'rgba(255, 255, 255, 0.4)',
    startColor,
    endColor,
    style,
  }) => {
    return (
      <Svg
        width={width ?? size}
        height={height ?? size}
        viewBox="0 0 16 16"
        style={style}
      >
        <Path
          d="M7.99997 1.14282C4.21247 1.14282 1.14282 4.21247 1.14282 7.99997V14.4285C1.14282 14.666 1.33389 14.8571 1.57139 14.8571H4.85711C5.48747 14.8571 5.99997 14.3446 5.99997 13.7143V9.99997C5.99997 9.36961 5.48747 8.85711 4.85711 8.85711H2.42854V7.99997C2.42854 4.92318 4.92318 2.42854 7.99997 2.42854C11.0768 2.42854 13.5714 4.92318 13.5714 7.99997V8.85711H11.1428C10.5125 8.85711 9.99997 9.36961 9.99997 9.99997V13.7143C9.99997 14.3446 10.5125 14.8571 11.1428 14.8571H14.4285C14.666 14.8571 14.8571 14.666 14.8571 14.4285V7.99997C14.8571 4.21247 11.7875 1.14282 7.99997 1.14282ZM4.71425 10.1428V13.5714H2.42854V10.1428H4.71425ZM13.5714 13.5714H11.2857V10.1428H13.5714V13.5714Z"
          fill="url(#paint0_linear_371_4127)"
        />
        <Defs>
          <LinearGradient
            id="paint0_linear_371_4127"
            x1="7.99996"
            y1="-2.00003"
            x2="7.99997"
            y2="14.8571"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor={startColor ?? color} />
            <Stop offset="1" stopColor={endColor ?? color} />
          </LinearGradient>
        </Defs>
      </Svg>
    );
  },
);
